/**
 * Created by rkotha on 8/17/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ImportantAnnouncementsController', ImportantAnnouncementsController);

    ImportantAnnouncementsController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$sce', 'entities', 'NasracWebContent'];

    function ImportantAnnouncementsController ($scope, Principal, LoginService, $state, $sce, entities, NasracWebContent) {
        var vm = this;
        vm.homePageAnnouncements = {
        		adminRoles: "Administrators"
        	};

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        var entity = entities[0];
        vm.nasrac_web_content = entity;
        $scope.trustedHtml = $sce.trustAsHtml(entity.content);
        $scope.tinymceModel = entity.content;
        vm.clear = $scope.cancelEditor

        $scope.editMode = false;

        $scope.tinymceOptions = {
            inline : false,
            plugins : [
                'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                'searchreplace wordcount visualblocks visualchars code fullscreen',
                'insertdatetime media nonbreaking save table contextmenu directionality',
                'template paste textcolor colorpicker textpattern imagetools codesample toc'
            ],
            toolbar : 'undo redo | fontselect | fontsizeselect | styleselect | bold italic | alignleft aligncenter alignright alignjustify | link bullist numlist outdent indent | print preview media fullpage | forecolor backcolor',
            fontsize_formats : '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
            skin : 'lightgray',
            theme : 'modern',
            height : 600
        };

        $scope.updateContents = function() {
            entity.content = $scope.tinymceModel;
            NasracWebContent.update(entity, onSaveSuccess, onSaveError);
            $scope.editMode = false;
        };

        $scope.cancelEditor = function() {
            $scope.editMode = false;
        }

        $scope.openEditor = function() {
            $scope.editMode = true;
        }



        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function register() {
            $state.go('register');
        }

        function onSaveSuccess(result) {
            $scope.editMode = false;
            $state.go('home-main.important-announcements', {}, {
             reload : 'home-main.important-announcements'
             });
        }

        function onSaveError() {
            $scope.editMode = true;
        }
    }
})();
